import { getFileFamily } from 'jamespot-user-api';
import * as React from 'react';
import { fileAvatar } from 'utils/utils.files';
import { JRCFileAudio } from './JRCFileAudio';
import { JRCFileVideo } from './JRCFileVideo';
import { JRCFileImage } from './JRCFileImage';
import { JRCFileProps } from './types';
import { JRCFileApplication } from './JRCFileApplication';
import { JRCFileFolder } from './JRCFileFolder';

export const JRCFile = ({ uri, mimetype, display, color, size }: JRCFileProps) => {
    const file = fileAvatar(mimetype);
    const fileFamily = getFileFamily(mimetype);

    switch (fileFamily) {
        default:
        case 'application':
            switch (file.ext) {
                default:
                    return <JRCFileApplication uri={uri} mimetype={mimetype} display={display} />;
            }
        case 'audio':
            return <JRCFileAudio uri={uri} mimetype={mimetype} display={display} />;
        case 'video':
            return <JRCFileVideo uri={uri} mimetype={mimetype} display={display} />;
        case 'gif':
            /**
             * GIF are currently poorly supported so we show them as an application
             */
            return <JRCFileApplication uri={uri} mimetype={mimetype} display={display} />;
        case 'image':
            return <JRCFileImage uri={uri} mimetype={mimetype} display={display} />;
        case 'folder':
            return <JRCFileFolder uri={uri} mimetype={mimetype} display={display} color={color} size={size} />;
    }
};
